export default {
    setFeedExportList(state, payload) {
        state.feedExportList = payload;
    }
}